var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notPage_box"},[_c('img',{attrs:{"src":require('@/assets/imgs/nonetwork.png'),"alt":""}}),_c('div',{staticClass:"backBtn",on:{"click":_vm.goback}},[_vm._v("重新登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }